export default {
  methods: {
    validateForm() {
      this.$v.$touch();
      return this.$v.$invalid;
    },
  },
};
